// extracted by mini-css-extract-plugin
export default {"pay":"pay-bar_pay__2YqAc"};